var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { getAutomation, getDebug } from '@citrus/runtime';
import Row from './Row';
import Column from './Column';
import { Styled } from './Sortable.styled';
var VERSION = '2.5.0';
var Item = function (_a) {
    var automationId = _a.automationId, id = _a.id, sectionId = _a.sectionId, children = _a.children, _b = _a.disabled, disabled = _b === void 0 ? false : _b, index = _a.index, gridLines = _a.gridLines, TYPE = _a.__TYPE;
    var css = [
        gridLines && index === 0 ? 'pcty-sortable-border-top' : '',
        !gridLines ? 'pcty-sortable-border-none' : '',
    ]
        .join(' ')
        .trim();
    return (React.createElement(Styled.Item, __assign({ className: disabled ? 'pcty-sortable-item-disabled' : 'pcty-sortable-draggable', "data-section-id": sectionId, id: id }, getAutomation(automationId, 'item'), getDebug(sessionStorage.getItem('citrus-debug') === 'true', TYPE, VERSION)),
        React.createElement(Styled.Column, { className: css },
            React.createElement(Styled.Handle, null)),
        renderChildren(children, index, gridLines)));
};
var renderChildren = function (children, index, gridLines) {
    var aryChildren = React.Children.toArray(children);
    if (aryChildren.length <= 0)
        return null;
    var addMarkup = function (child) { return (__assign(__assign({}, child), { props: __assign(__assign({}, child.props), { index: index, gridLines: gridLines, children: (React.createElement("div", { className: 'pcty-sortable-column-inner' },
                React.createElement("div", { className: 'pcty-sortable-column-inner-column' },
                    React.createElement(Styled.Handle, null)),
                React.createElement("div", { className: 'pcty-sortable-column-inner-column' }, child.props.children))) }) })); };
    if (aryChildren.length === 1 && typeof aryChildren[0] === 'string') {
        return (React.createElement(Row, null,
            React.createElement(Column, { gridLines: gridLines, index: index },
                React.createElement("div", { className: 'pcty-sortable-column-inner' },
                    React.createElement("div", { className: 'pcty-sortable-column-inner-column' },
                        React.createElement(Styled.Handle, null)),
                    React.createElement("div", { className: 'pcty-sortable-column-inner-column' }, children)))));
    }
    if (aryChildren.length > 1 || (aryChildren.length >= 1 && aryChildren[0].props.__TYPE !== 'Row')) {
        return children[0];
    }
    if (!Array.isArray(aryChildren[0].props.children)) {
        aryChildren[0] = __assign(__assign({}, aryChildren[0]), { props: __assign(__assign({}, aryChildren[0].props), { children: addMarkup(aryChildren[0].props.children) }) });
        return aryChildren;
    }
    var grandchildren = aryChildren[0].props.children.map(function (child, i) {
        if (!child || !child.props || child.props.__TYPE !== 'Column')
            return null;
        if (i === 0) {
            // add markup
            return addMarkup(child);
        }
        return child;
    });
    aryChildren[0] = grandchildren;
    return aryChildren;
};
Item.defaultProps = {
    __TYPE: 'Item',
};
export default Item;
